import type * as Fire from 'firebase/firestore';
import type { QueryBuildResponse, QueryFilterSchema } from './QueryBuilder';

import QueryBuilder from './QueryBuilder';

export const mergeFilters = (a: QueryFilterSchema, b: QueryFilterSchema): QueryFilterSchema => {
  if (Array.isArray(a)) {
    if (Array.isArray(b)) return [...a, ...b];
    return [...a, b];
  }
  if (Array.isArray(b)) return [a, ...b];
  return [a, b];
};

export const queryCollection = (params: {
  database: Fire.Firestore;
  collectionName: string;
  filters?: QueryFilterSchema;
  disableSort?: boolean;
  logger?: boolean;
  isCollectionGroup?: boolean;
}): QueryBuildResponse => {
  const {
    database,
    collectionName,
    filters,
    disableSort,
    logger,
    isCollectionGroup = false,
  } = params;
  const builder = new QueryBuilder(database, collectionName);
  if (typeof filters === 'function') {
    filters(builder);
  } else {
    for (const entry of filters ?? []) {
      if (typeof entry === 'function') {
        entry(builder);
      } else {
        const when = typeof entry.when === 'function' ? entry.when() : entry.when;
        if (!when) continue;
        if (!entry.value) continue;
        const value = entry.value(builder);
        if (!value) continue;
      }
    }
  }
  if (disableSort) builder.disableSort();
  if (logger) builder.enableDebugger();

  const { query, debug } = builder.buildQuery(isCollectionGroup);
  return { query, debug };
};
